import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import get from 'lodash/get'
import { IGroupParam } from '../../types/router'
import { AppStateType } from '../../reducers'
import { AREA_CONSTANTS } from '../../services/auth'
import { selectGroupsList, selectGroupById } from '../../selectors/groups'
import { selectPublishedSearch } from '../../selectors/publishedSearch'
import { selectAreaWritable } from '../../selectors/auth'
import { GroupViewPage as Component } from './GroupViewPage'

const mapStateToProps = (
  state: AppStateType,
  ownProps: RouteComponentProps<IGroupParam>
) => ({
  groupsList: selectGroupsList(state),
  groupsLoading: state.groups.isLoading,
  groupsLoaded: state.groups.isLoaded,
  group: selectGroupById(get(ownProps, 'match.params.groupId', ''))(state),
  search: selectPublishedSearch(state),
  hasGroupAccess: selectAreaWritable(state, {
    ...ownProps,
    area: AREA_CONSTANTS.GROUP_PUBLISHING_AREA,
  }),
})

export const GroupViewPage = withRouter(
  connect(mapStateToProps)(Component)
) as React.FC<{}>
